import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedRoutingModule } from './shared-routing.module';
import { HomeHeaderComponent } from './home-header-footer/home-header/home-header.component';
import { HomeFooterComponent } from './home-header-footer/home-footer/home-footer.component';
import { DashboardFooterComponent } from './dashboard-header-footer/dashboard-footer/dashboard-footer.component';
import { DashboardHeaderComponent } from './dashboard-header-footer/dashboard-header/dashboard-header.component';
import { P404Component } from './error/p404/p404.component';
import { P500Component } from './error/p500/p500.component';
// requires BrowserAnimationsModule
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import HeadroomModule
import { HeadroomModule } from '@ctrl/ngx-headroom';

@NgModule({
  declarations: [
    HomeHeaderComponent,
    HomeFooterComponent,
    DashboardFooterComponent,
    DashboardHeaderComponent,
    P404Component,
    P500Component
  ],
  exports: [
    HomeHeaderComponent,
    HomeFooterComponent,
    DashboardFooterComponent,
    DashboardHeaderComponent
  ],
  imports: [
    CommonModule,
    SharedRoutingModule,
    BrowserAnimationsModule,
    HeadroomModule
  ]
})
export class SharedModule { }
